const TECHNICAL_NUMERIC_LENGTH = 14

const trimString = (value) => String(value || '').trim()

const normalizeDigits = (value) => trimString(value).replace(/\D+/g, '')

const isTechnicalIdentifier = (value) => {
	const normalized = trimString(value)
	if (!normalized) {
		return false
	}

	if (normalized.includes('@lid')) {
		return true
	}

	if (normalized.includes('@')) {
		return false
	}

	const digits = normalizeDigits(normalized)
	return digits === normalized && digits.length >= TECHNICAL_NUMERIC_LENGTH
}

const isHumanReadableName = (value) => {
	const normalized = trimString(value)
	if (!normalized) {
		return false
	}

	if (normalized.includes('@lid')) {
		return false
	}

	const digits = normalizeDigits(normalized)
	return digits !== normalized || digits.length < TECHNICAL_NUMERIC_LENGTH
}

export const isTechnicalConversation = (conversation) => {
	if (!conversation || conversation?.type === 'GROUP') {
		return false
	}

	const conversationId = trimString(conversation?.id || conversation?.remoteJid || conversation?.remote_jid)
	const conversationName = trimString(conversation?.name)
	const kwikContactName = trimString(conversation?.kwik_contact_name)

	if (isHumanReadableName(kwikContactName) || isHumanReadableName(conversationName)) {
		return false
	}

	return isTechnicalIdentifier(conversationId) || isTechnicalIdentifier(conversationName)
}

export const getVisibleConversations = (conversations = []) => {
	const technicalConversations = conversations.filter(isTechnicalConversation)
	if (!technicalConversations.length) {
		return conversations
	}

	const humanConversations = conversations.filter((conversation) => !isTechnicalConversation(conversation))
	return humanConversations.length ? humanConversations : conversations
}
